import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=f11a2a80&scoped=true&"
import script from "./ClientPage.vue?vue&type=script&lang=js&"
export * from "./ClientPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=f11a2a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11a2a80",
  null
  
)

export default component.exports